<div mat-dialog-title class="title">
  <div class="flex-align">
    @if (data?.title) {
    <div class="title-text">
      <h2><ng-container *ngTemplateOutlet="data?.title ?? null; context: { $implicit: context }"></ng-container></h2>
    </div>
    } @if (data?.size !== 'phone') {
    <button mat-dialog-close class="close">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    } @else {
    <button class="close" (click)="dismiss()">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    }
  </div>
</div>
@if (data?.content) {
<mat-dialog-content id="modal-bottomsheet-content">
  <ng-container *ngTemplateOutlet="data?.content ?? null; context: { $implicit: context }"></ng-container>
</mat-dialog-content>
} @if (data?.actions) {
<mat-dialog-actions id="modal-bottomsheet-actions">
  <ng-container *ngTemplateOutlet="data?.actions ?? null; context: { $implicit: context }"></ng-container>
</mat-dialog-actions>
}
